/* ==========================================================================
   OliveDrab — search
   Animated placeholder keywords, predictive results via Shopify's section
   rendering API, a client side intent layer that answers common questions,
   recent searches, and full keyboard support.

   No dependencies. Loaded with defer.
   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.ODConfig || {};
  var routes = cfg.routes || {};
  var SECTION = 'od-predictive-search';
  var RECENT_KEY = 'od_recent_searches';
  var RECENT_MAX = 5;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function reduced() {
    return window.OD && window.OD.prefersReduced ? window.OD.prefersReduced() : false;
  }

  /* ------------------------------------------------------- local storage */

  function readRecent() {
    try {
      var raw = localStorage.getItem(RECENT_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (s) { return typeof s === 'string'; }) : [];
    } catch (e) { return []; }
  }

  function pushRecent(term) {
    if (!term) return;
    try {
      var list = readRecent().filter(function (t) {
        return t.toLowerCase() !== term.toLowerCase();
      });
      list.unshift(term);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
    } catch (e) { /* private mode, nothing to do */ }
  }

  function clearRecent() {
    try { localStorage.removeItem(RECENT_KEY); } catch (e) {}
  }

  /* ============================================================ instance */

  function ODSearch(form) {
    this.form = form;
    this.input = $('.od-search__input', form);
    this.clearBtn = $('.od-search__clear', form);
    this.panel = $('[data-od-ps]', form);
    this.body = $('[data-od-ps-body]', form);
    this.loading = $('[data-od-ps-loading]', form);
    this.idle = $('[data-od-ps-idle]', form);
    this.foot = $('[data-od-ps-foot]', form);
    this.allLink = $('[data-od-ps-all]', form);
    this.empty = $('[data-od-ps-empty]', form);
    this.status = $('[data-od-ps-status]', form);
    this.ai = $('[data-od-ai]', form);
    this.aiBody = $('[data-od-ai-body]', form);
    this.aiCta = $('[data-od-ai-cta]', form);
    this.aiCtaText = $('[data-od-ai-cta-text]', form);

    if (!this.input) return;

    this.predictive = form.dataset.predictive === 'true' && !!this.panel;
    this.limit = parseInt(form.dataset.limit, 10) || 6;
    this.types = form.dataset.types || 'product';
    this.useRecent = form.dataset.recent === 'true';

    this.keywords = $$('[data-od-keywords] span', form).map(function (s) { return s.textContent; });
    this.prefix = form.dataset.prefix || '';
    this.effect = form.dataset.effect || 'typewriter';
    this.hold = parseInt(form.dataset.hold, 10) || 1800;
    this.speed = parseInt(form.dataset.speed, 10) || 45;

    this.intents = $$('[data-od-intents] span', form).map(function (s) {
      return {
        kw: (s.dataset.kw || '').toLowerCase(),
        title: s.dataset.title || '',
        url: s.dataset.url || '',
        count: s.dataset.count || ''
      };
    });

    this.controller = null;
    this.debounce = null;
    this.cache = {};
    this.options = [];
    this.active = -1;
    this.open = false;

    this.bind();
    this.startTypewriter();
    this.renderRecent();
  }

  /* ------------------------------------------------------------- binding */

  ODSearch.prototype.bind = function () {
    var self = this;

    this.input.addEventListener('input', function () {
      self.stopTypewriter();
      self.toggleClear();
      if (!self.predictive) return;
      var q = self.input.value.trim();
      clearTimeout(self.debounce);
      if (q.length < 2) {
        self.showIdle();
        return;
      }
      self.debounce = setTimeout(function () { self.query(q); }, 220);
    });

    this.input.addEventListener('focus', function () {
      self.stopTypewriter();
      if (!self.predictive) return;
      var q = self.input.value.trim();
      if (q.length >= 2) self.query(q);
      else self.showIdle();
    });

    this.input.addEventListener('keydown', function (e) { self.onKey(e); });

    this.form.addEventListener('submit', function () {
      var q = self.input.value.trim();
      if (q && self.useRecent) pushRecent(q);
    });

    this.form.addEventListener('reset', function () {
      setTimeout(function () {
        self.toggleClear();
        self.showIdle();
        self.startTypewriter();
        self.input.focus();
      }, 0);
    });

    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self.input.value = '';
        self.toggleClear();
        self.showIdle();
        self.input.focus();
      });
    }

    var recentClear = $('[data-od-recent-clear]', this.form);
    if (recentClear) {
      recentClear.addEventListener('click', function (e) {
        e.preventDefault();
        clearRecent();
        self.renderRecent();
      });
    }

    // close on outside click, but never while focus is still inside
    document.addEventListener('click', function (e) {
      if (!self.open) return;
      if (self.form.contains(e.target)) return;
      self.close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.open) {
        self.close();
        self.input.focus();
      }
    });

    this.toggleClear();
  };

  ODSearch.prototype.toggleClear = function () {
    if (!this.clearBtn) return;
    this.clearBtn.hidden = this.input.value.length === 0;
  };

  /* --------------------------------------------------------- typewriter */

  ODSearch.prototype.startTypewriter = function () {
    var self = this;
    if (!this.keywords.length) return;
    if (!cfg.motion || reduced()) {
      this.input.placeholder = this.decorate(this.keywords[0]);
      return;
    }
    if (this.input.value) return;

    this.kwIndex = 0;
    this.charIndex = 0;
    this.deleting = false;

    if (this.effect !== 'typewriter') {
      this.swapLoop();
      return;
    }
    this.typeLoop();
  };

  ODSearch.prototype.decorate = function (word) {
    return this.prefix ? this.prefix + ' “' + word + '”' : word;
  };

  ODSearch.prototype.typeLoop = function () {
    var self = this;
    if (this.stopped || this.input.value) return;

    var word = this.keywords[this.kwIndex % this.keywords.length];
    var shown = word.slice(0, this.charIndex);
    this.input.placeholder = this.decorate(shown);

    var delay = this.speed;

    if (!this.deleting) {
      if (this.charIndex < word.length) {
        this.charIndex++;
      } else {
        this.deleting = true;
        delay = this.hold;
      }
    } else {
      if (this.charIndex > 0) {
        this.charIndex--;
        delay = Math.max(12, this.speed * 0.5);
      } else {
        this.deleting = false;
        this.kwIndex++;
        delay = 260;
      }
    }

    this.timer = setTimeout(function () { self.typeLoop(); }, delay);
  };

  ODSearch.prototype.swapLoop = function () {
    var self = this;
    if (this.stopped || this.input.value) return;
    var word = this.keywords[this.kwIndex % this.keywords.length];
    this.input.placeholder = this.decorate(word);
    this.kwIndex++;
    this.timer = setTimeout(function () { self.swapLoop(); }, this.hold + 600);
  };

  ODSearch.prototype.stopTypewriter = function () {
    this.stopped = true;
    clearTimeout(this.timer);
    if (this.input.value) {
      this.input.placeholder = this.prefix || '';
    }
  };

  /* ------------------------------------------------------------ intents */

  ODSearch.prototype.matchIntent = function (q) {
    var needle = q.toLowerCase();
    var best = null;
    for (var i = 0; i < this.intents.length; i++) {
      var it = this.intents[i];
      if (!it.kw) continue;
      if (needle.indexOf(it.kw) > -1) {
        // longest keyword wins, so "office" beats a generic match
        if (!best || it.kw.length > best.kw.length) best = it;
      }
    }
    return best;
  };

  ODSearch.prototype.renderAI = function (q) {
    if (!this.ai) return;
    var hit = this.matchIntent(q);
    if (!hit) { this.ai.hidden = true; return; }

    var sentence = hit.title;
    if (hit.count) {
      sentence += ' — ' + hit.count + (hit.count === '1' ? ' piece' : ' pieces') + ' in this edit.';
    } else {
      sentence += '.';
    }

    this.aiBody.textContent = sentence;
    this.aiCta.href = hit.url;
    this.aiCtaText.textContent = 'Open ' + hit.title;
    this.ai.hidden = false;
  };

  /* -------------------------------------------------------------- query */

  ODSearch.prototype.query = function (q) {
    var self = this;

    this.panelOpen();
    this.renderAI(q);

    if (this.cache[q]) {
      this.paint(this.cache[q], q);
      return;
    }

    if (this.controller) this.controller.abort();
    this.controller = ('AbortController' in window) ? new AbortController() : null;

    if (this.idle) this.idle.hidden = true;
    if (this.loading) this.loading.hidden = false;
    if (this.empty) this.empty.hidden = true;

    var base = routes.predictive || '/search/suggest';
    var url = base +
      '?q=' + encodeURIComponent(q) +
      '&section_id=' + SECTION +
      '&resources[type]=' + encodeURIComponent(this.types) +
      '&resources[limit]=' + this.limit +
      '&resources[options][unavailable_products]=last';

    fetch(url, this.controller ? { signal: this.controller.signal } : undefined)
      .then(function (res) {
        if (!res.ok) throw new Error('Search failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        self.cache[q] = html;
        self.paint(html, q);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (self.loading) self.loading.hidden = true;
        // a failed suggestion must never trap the shopper: the form still submits
        if (self.body) self.body.innerHTML = '';
        if (self.empty) self.empty.hidden = false;
      });
  };

  ODSearch.prototype.paint = function (html, q) {
    if (this.loading) this.loading.hidden = true;
    if (this.idle) this.idle.hidden = true;
    if (!this.body) return;

    // the section response is a full document fragment; take just our grid
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var grid = tmp.querySelector('[data-od-ps-count]');
    this.body.innerHTML = grid ? grid.outerHTML : '';

    var count = grid ? parseInt(grid.getAttribute('data-od-ps-count'), 10) || 0 : 0;

    if (this.empty) this.empty.hidden = count !== 0 || !!(this.ai && !this.ai.hidden);
    if (this.foot) this.foot.hidden = count === 0;
    if (this.allLink) {
      this.allLink.href = (routes.search || '/search') + '?q=' + encodeURIComponent(q);
      var label = $('span', this.allLink);
      if (label) label.textContent = count ? 'See all results for “' + q + '”' : 'Search for “' + q + '”';
    }

    this.collectOptions();
    this.announce(count, q);
  };

  ODSearch.prototype.announce = function (count, q) {
    if (!this.status) return;
    this.status.textContent = count
      ? count + ' result' + (count === 1 ? '' : 's') + ' for ' + q
      : 'No results for ' + q;
  };

  /* ---------------------------------------------------------- panel state */

  ODSearch.prototype.panelOpen = function () {
    if (!this.panel || this.open) return;
    this.panel.hidden = false;
    this.open = true;
    this.input.setAttribute('aria-expanded', 'true');
    this.form.classList.add('is-open');
    document.documentElement.classList.add('od-search-open');
  };

  ODSearch.prototype.close = function () {
    if (!this.panel) return;
    this.panel.hidden = true;
    this.open = false;
    this.active = -1;
    this.input.setAttribute('aria-expanded', 'false');
    this.input.removeAttribute('aria-activedescendant');
    this.form.classList.remove('is-open');
    document.documentElement.classList.remove('od-search-open');
  };

  ODSearch.prototype.showIdle = function () {
    if (!this.panel) return;
    if (this.body) this.body.innerHTML = '';
    if (this.loading) this.loading.hidden = true;
    if (this.empty) this.empty.hidden = true;
    if (this.foot) this.foot.hidden = true;
    if (this.ai) this.ai.hidden = true;

    this.renderRecent();

    var hasIdle = this.idle && this.idle.children.length;
    if (hasIdle) {
      this.idle.hidden = false;
      this.panelOpen();
    } else {
      this.close();
    }
    this.collectOptions();
  };

  ODSearch.prototype.renderRecent = function () {
    var group = $('[data-od-recent]', this.form);
    var list = $('[data-od-recent-list]', this.form);
    if (!group || !list) return;

    if (!this.useRecent) { group.hidden = true; return; }

    var items = readRecent();
    if (!items.length) { group.hidden = true; return; }

    list.innerHTML = '';
    var searchUrl = routes.search || '/search';
    items.forEach(function (term) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'od-chip od-chip--sm';
      a.href = searchUrl + '?q=' + encodeURIComponent(term);
      a.textContent = term;
      li.appendChild(a);
      list.appendChild(li);
    });
    group.hidden = false;
  };

  /* ------------------------------------------------------ keyboard nav */

  ODSearch.prototype.collectOptions = function () {
    this.options = this.panel ? $$('[data-od-ps-option]', this.panel) : [];
    this.options.forEach(function (li, i) {
      if (!li.id) li.id = 'od-ps-opt-' + i;
      li.setAttribute('aria-selected', 'false');
      li.classList.remove('is-active');
    });
    this.active = -1;
  };

  ODSearch.prototype.move = function (delta) {
    if (!this.options.length) return;
    if (this.active > -1) {
      this.options[this.active].setAttribute('aria-selected', 'false');
      this.options[this.active].classList.remove('is-active');
    }
    this.active += delta;
    if (this.active < 0) this.active = this.options.length - 1;
    if (this.active >= this.options.length) this.active = 0;

    var li = this.options[this.active];
    li.setAttribute('aria-selected', 'true');
    li.classList.add('is-active');
    this.input.setAttribute('aria-activedescendant', li.id);
    if (li.scrollIntoView) li.scrollIntoView({ block: 'nearest' });
  };

  ODSearch.prototype.onKey = function (e) {
    if (!this.open) {
      if (e.key === 'ArrowDown' && this.input.value.trim().length >= 2) {
        this.query(this.input.value.trim());
      }
      return;
    }

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        this.move(1);
        break;
      case 'ArrowUp':
        e.preventDefault();
        this.move(-1);
        break;
      case 'Enter':
        if (this.active > -1) {
          var link = $('a', this.options[this.active]);
          if (link) {
            e.preventDefault();
            var q = this.input.value.trim();
            if (q && this.useRecent) pushRecent(q);
            window.location.href = link.href;
          }
        }
        break;
      case 'Tab':
        this.close();
        break;
      default:
        break;
    }
  };

  /* ============================================================== init */

  function init(ctx) {
    $$('[data-od-search]', ctx || document).forEach(function (form) {
      if (form.dataset.odBound) return;
      form.dataset.odBound = '1';
      try {
        new ODSearch(form);
      } catch (e) {
        if (window.console && console.warn) console.warn('[OD search]', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.OD = window.OD || {};
  window.OD.initSearch = init;
})();
